import { jsx as _jsx } from "react/jsx-runtime";
import { useStatefulConnect as widgetUseStatefulConnect } from '@rango-dev/widget-embedded';
import { createContext, useContext } from 'react';
export const StatefulConnectContext = createContext(null);
export const StatefulConnectContextProvider = ({ children }) => {
    const statefulConnect = widgetUseStatefulConnect();
    return (_jsx(StatefulConnectContext.Provider, { value: statefulConnect, children: children }));
};
export const useStatefulConnect = () => {
    const context = useContext(StatefulConnectContext);
    if (!context) {
        throw new Error('useStatefulConnect must be used within a StatefulConnectContextProvider');
    }
    return context;
};
